const groupMessages = {
  'group.header.title': 'グループ管理',
  'group.header.search.name': 'グループ名',
  'group.header.search.placeholder.name': 'グループ名で絞り込み',
  'group.header.checkbox.label': '削除済みのグループを含める',
  'group.list.header.number': 'グループNo',
  'group.list.header.name': 'グループ名',
  'group.list.header.tagSet': 'タグセット',
  'group.list.header.lastUpdatedDate': '最終更新日',
  'group.list.header.address': '住所',
  'group.list.batch.deletedGroup': '削除済み',
  'group.dialog.title': 'グループ詳細',
  'group.dialog.button.disable': 'グループ運用を終了',
  'group.dialog.button.enable': 'グループ運用を開始',
  'group.detail.header.title': 'グループ詳細',
  'group.detail.button.edit': '編集',
  'group.detail.button.delete': '削除',
  'group.detail.button.update': '更新',
  'group.detail.button.cancel': 'キャンセル',
  'group.detail.button.add': '追加',
  'group.detail.groupNumber': 'グループNo',
  'group.detail.groupName': 'グループ名',
  'group.detail.tagSet': 'タグセット',
  'group.detail.address': '住所',
  'group.detail.registrationDate': '登録日',
  'group.detail.lastUpdatedDate': '最終更新日',
  'group.detail.assignees': '担当者',
  'group.creation.header.title': 'グループ追加',
  'selectGroup.dialog.checkbox.label': '削除済みのグループを含める',
  'selectGroup.dialog.allGroups': 'すべて',
};

export default groupMessages;
